/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class CostVariationByDimensionWidgetConfiguration extends models.BaseDimensionWidgetConfiguration {
    constructor() {
        super();
        this.setDiscriminator("CostVariationByDimensionWidgetConfiguration");
    }

    getFixupPrototypeFunction() { return CostVariationByDimensionWidgetConfiguration.fixupPrototype; }

    static newInstance(model: Partial<CostVariationByDimensionWidgetConfiguration>): CostVariationByDimensionWidgetConfiguration {
        let obj = Object.assign(new CostVariationByDimensionWidgetConfiguration(), model);
        CostVariationByDimensionWidgetConfiguration.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<CostVariationByDimensionWidgetConfiguration>): CostVariationByDimensionWidgetConfiguration {
        if (!model) return null;
        return CostVariationByDimensionWidgetConfiguration.newInstance(<CostVariationByDimensionWidgetConfiguration> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: CostVariationByDimensionWidgetConfiguration) {
        if (!obj) return;

        models.CostVariationByDimensionWidgetConfiguration.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: CostVariationByDimensionWidgetConfiguration): boolean {
        if (models.BaseDimensionWidgetConfiguration.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, CostVariationByDimensionWidgetConfiguration.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

}
